import { registerPlugin , Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { Device } from '@capacitor/device';
import { Share } from '@capacitor/share';
import arrays from '../constants/array'
import i18n from './i18n'

if(!localStorage.getItem('language'))
Device.getLanguageCode().then(language=>{
    arrays.languages.forEach((lang)=>{
        if(lang.value.substring(0,2)===language.value || lang.value===language.value){
            localStorage.setItem('language',language.value)
            i18n.locale=language.value
        }
    })
})

const Echo = registerPlugin('Echo');
const platform =Capacitor.getPlatform();
App.addListener('backButton',()=>{
    if(window.location.pathname==='/')
    App.exitApp();
    else
    window.history.back()
    
})

export  {Echo,platform,Device,Share};